import { c as _c } from "react/compiler-runtime";
import type { SxProps } from '@mui/material';
import { FlexBox } from '../FlexBox';
type Props = React.PropsWithChildren<{
  sx?: SxProps;
}>;
export const Page = t0 => {
  const $ = _c(5);
  const {
    children,
    sx
  } = t0;
  let t1;
  if ($[0] !== sx) {
    t1 = {
      width: "100vw",
      height: "5vh",
      ...sx
    };
    $[0] = sx;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <FlexBox sx={t1}>{children}</FlexBox>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};